var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title',[_vm._v("销售单管理")]),_vm._v(" "),_c('section',{staticClass:"mainPart"},[_c('CompanyTab',{attrs:{"active":_vm.currentTit}}),_vm._v(" "),_c('SaleOrderList',{attrs:{"saleOrderType":0}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81abe270","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/OrderFolder/StoreSale/SalesOrderManage.vue
// module id = null
// module chunks = 